// extracted by mini-css-extract-plugin
export default {"heading":"heading__aL4m-","paragraph":"paragraph__aEviD","submitButton":"submitButton__qBKMY"};